export default "/assets/images/filter-critter-cuddler-box.png?a706042f2d3aea6b51a669b44fbbbbae";